module.exports = __webpack_public_path__ + "static/media/power-x-gym.1f3b58aa.png";